// extracted by mini-css-extract-plugin
module.exports = {"clamped":"ReadMore_clamped__1L0vp","expanded":"ReadMore_expanded__3Wo7t"};